/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import * as React from "react";
import { Text } from "@fluentui/react";

const ViewSectionTitle = (props: { text: string }): JSX.Element => (
    <h3>
        <Text variant="xLarge">{props.text}</Text>
    </h3>
);

export default ViewSectionTitle;
